import {Component} from '@angular/core';

@Component({
  selector: 'admin-footer',
  templateUrl: './admin-footer.component.html',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './admin-footer.component.scss']
})

export class AdminFooterComponent {

}